<div class="modal-body">
    <div class="row">
        <div class="col-auto">
            Are you sure you want to delete this entry?
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" (click)="close()" class="btn btn-sb border-lb text-uppercase m-100">Yes</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-uppercase m-100">No</button>
</div>